import { Link } from 'react-router-dom';

import { FOCO_VISIVEL } from 'utils/foco';

interface CabecalhoDoExtratoProps {
  titulo: string;
  emApuracao: boolean;
}

/** Voltar, título da página e a pílula "Em apuração" (PREM-01). */
export default function CabecalhoDoExtrato({ titulo, emApuracao }: CabecalhoDoExtratoProps) {
  return (
    <div className="mb-[22px] flex flex-wrap items-center gap-3.5">
      <Link
        to="/"
        aria-label="Voltar"
        className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue ${FOCO_VISIVEL}`}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--brand-yellow)" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
          <path d="m15 18-6-6 6-6" />
        </svg>
      </Link>
      <h1 tabIndex={0} className={`m-0 font-display text-[24px] font-extrabold leading-[normal] text-brand-blue-dark sm:text-[28px] ${FOCO_VISIVEL}`}>
        {titulo}
      </h1>
      {emApuracao && (
        // SPEC_DEVIATION: fundo `brand-blue-dark` (design `brand-blue`, 4,44:1 com o texto amarelo de 12px).
        <span
          tabIndex={0}
          className={`ml-auto inline-flex items-center gap-[7px] rounded-full bg-brand-blue-dark px-4 py-2 font-display text-[12px] font-bold text-brand-yellow ${FOCO_VISIVEL}`}
        >
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
          </svg>
          Em apuração
        </span>
      )}
    </div>
  );
}
